export default __webpack_public_path__ + "static/finalist seal_NSW_Best Independent Office-1d5005c4cf7089eee6476bd4983ba162.png";